import { inject, Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { SoldToAccountsService } from '../services/sold-to.service';
import { Store } from '@ngrx/store';
import { ISoldToAddressesResponse } from '../models/soldTo-selection.models';
import * as CustomerSelectors from '../reducers/customer.reducer';
import { IAddress } from '../models/common.models';
import { EGlueResource } from '../configurations/common';

@Injectable({
  providedIn: 'root',
})
export class SoldToAccountsFacade {
  private readonly injector: Injector = inject(Injector);
  private readonly store: Store = inject(Store);
  private pSoldToAccountsService: SoldToAccountsService | undefined;

  /**
   * @returns {SoldToAccountsService}
   */
  public get soldToService(): SoldToAccountsService {
    if (!this.pSoldToAccountsService) {
      this.pSoldToAccountsService = this.injector.get(SoldToAccountsService);
    }
    return this.pSoldToAccountsService;
  }

  /**
   * @param {EGlueResource[]} includes
   * @returns {Observable<ISoldToAddressesResponse>}
   */
  getSoldToAccounts(includes: EGlueResource[] = []): Observable<ISoldToAddressesResponse> {
    return this.soldToService.getSoldToAccounts(includes);
  }

  /**
   * @param {string} soldToId
   * @param {EGlueResource[]} includes
   * @returns {Observable<ISoldToAddressesResponse>}
   */
  getSoldToAccountsById(soldToId: string, includes: EGlueResource[] = []): Observable<ISoldToAddressesResponse> {
    return this.soldToService.getSoldToAccountsById(soldToId, includes);
  }

  /**
   * @returns {Observable<IAddress[]>}
   */
  selectSoldToAccounts(): Observable<IAddress[] | null> {
    return this.store.select(CustomerSelectors.selectCustomerSoldToAddresses);
  }

  selectAreSoldToAddressesLoaded(): Observable<boolean> {
    return this.store.select(CustomerSelectors.selectAreSoldToAddressesLoaded);
  }
}
